import { render, staticRenderFns } from "./MerchantCategories.vue?vue&type=template&id=fcea5a72&scoped=true&"
import script from "./MerchantCategories.vue?vue&type=script&lang=js&"
export * from "./MerchantCategories.vue?vue&type=script&lang=js&"
import style0 from "./MerchantCategories.vue?vue&type=style&index=0&id=fcea5a72&prod&lang=scss&scoped=true&"
import style1 from "./MerchantCategories.vue?vue&type=style&index=1&id=fcea5a72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcea5a72",
  null
  
)

export default component.exports